/*******************************************************************
* PAGE        : PaginationComponent
* REMARKS     :
* CREATED ON  : 15-07-2026
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 15-07-2026
********************************************************************/

import React, { useEffect, useState } from 'react';
import './PaginationComponent.css';
import { Images } from '../../utils/Images';

// #region Component
const PaginationComponent = ({ page, onPageChange, totalPages }) => {

    // #region States
    const currentPage = page + 1;

    // local input state so typing doesn't fight the controlled `page` prop
    const [inputValue, setInputValue] = useState(String(currentPage));

    useEffect(() => {
        setInputValue(String(currentPage));
    }, [currentPage]);

    const isFirst = page === 0;
    const isLast = page >= totalPages - 1;
    // #endregion

    // #region Methods
    const goToPage = (e, targetPage /* 0-based */) => {
        const clamped = Math.min(Math.max(targetPage, 0), totalPages - 1);
        if (clamped !== page) onPageChange(e, clamped);
        setInputValue(String(clamped + 1));
    };

    const commitInput = (e) => {
        const parsed = parseInt(inputValue, 10);
        if (Number.isNaN(parsed)) {
            setInputValue(String(currentPage)); // reset on invalid entry
            return;
        }
        goToPage(e, parsed - 1);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            commitInput(e);
            e.target.blur();
        }
    };

    // #endregion

    return (
        <React.Fragment>
            <div className="custom-pagination-actions">

                {/* FIRST */}
                <button
                    className={`page-btn ${isFirst ? "disabled" : "active-btn"}`}
                    style={{ cursor: isFirst ? "default" : "pointer", border: 'none' }}
                    disabled={isFirst}
                    onClick={(e) => goToPage(e, 0)}
                    aria-label="First page"
                >
                    {/* {"<<"} F4F7FB*/}
                    <img src={Images.firstpageicon} alt="First" className="pagination-icon" />
                </button>

                {/* PREVIOUS */}
                <button
                    className={`page-btn ${isFirst ? "disabled" : "active-btn"}`}
                    style={{ cursor: isFirst ? "default" : "pointer", border: 'none' }}
                    disabled={isFirst}
                    onClick={(e) => goToPage(e, page - 1)}
                    aria-label="Previous page"
                >
                    {/* {"<"} */}
                    <img src={Images.prevpageicon} alt="First" className="pagination-icon" />
                </button>

                {/* PAGE INPUT */}
                <input
                    type="number"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="goto-page-input"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onBlur={commitInput}
                    onKeyDown={handleKeyDown}
                    aria-label={`Page ${currentPage} of ${totalPages}`}
                />
                {/* <span className="page-input-total">/ {totalPages}</span> */}

                {/* NEXT */}
                <button
                    className={`page-btn ${isLast ? "disabled" : "active-btn"}`}
                    style={{ cursor: isLast ? "default" : "pointer", border: 'none' }}
                    disabled={isLast}
                    onClick={(e) => goToPage(e, page + 1)}
                    aria-label="Next page"
                >
                    {/* {">"} */}
                    <img src={Images.nextpageicon} alt="First" className="pagination-icon" />
                </button>

                {/* LAST */}
                <button
                    className={`page-btn ${isLast ? "disabled" : "active-btn"}`}
                    style={{ cursor: isLast ? "default" : "pointer", border: 'none' }}
                    disabled={isLast}
                    onClick={(e) => goToPage(e, totalPages - 1)}
                    aria-label="Last page"
                >
                    {/* {">>"} */}
                    <img src={Images.lastpageicon} alt="First" className="pagination-icon" />
                </button>

            </div>
        </React.Fragment>
    );
};
// #endregion

export default PaginationComponent;